import { merge } from 'lodash';

type PlatformResult = { [key: string]: any };

interface PlatformsObject {
	default?: PlatformResult;
	web?: PlatformResult;
	native?: PlatformResult;
	ios?: PlatformResult;
	android?: PlatformResult;
}

/**
 * Helper component to expand other components depending on the platform being
 *
 * @returns {object} OS platform and a 'select' function to return a new object with the properties corresponding to the platform being used.
 */
export const Platform = {
	OS: 'web',
	select: function (obj: PlatformsObject): PlatformResult {
		return merge({}, obj.default || {}, obj.web || {}) as PlatformResult;
	},
};
